import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Componente from "./Componentes";
import PrazoPagto from "./PrazoPagto";
import { formatMoeda, goToFocus, handleNumberOnly, strToFloat, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { useRef, useState } from "react";
import { CompPagFrete, infPagInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { addInfPag, removeInfPag, removeInfPagTodos } from "../../../features/manifestoSlice";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: infPagInterface = {
    id: 0,
    CNPJIPEF: '',
    codAgencia: '',
    codBanco: '',
    cpfcnpj: '',
    idestrangeiro: false,
    indPag: 0,
    PIX: '',
    vContrato: 0,
    comp: [],
    infPrazo: [],
    indAltoDesemp: 0,
    indAntecipaAdiant: 0,
    tpAntecip: 0,
    vAdiant: 0,
    xNome: ''
}

export default function InfPagFrete() {
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.infANTT?.infPag);
    const [form, setForm] = useState<infPagInterface>(initialForm)
    const codBancoRef = useRef<HTMLInputElement>(null);
    const codAgenciaRef = useRef<HTMLInputElement>(null);
    const cpfCnpjRef = useRef<HTMLInputElement>(null);
    const CNPJIPEFRef = useRef<HTMLInputElement>(null);
    const vContratoRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const validaPreenchimento = () => {
        if (form.cpfcnpj.trim() === "") {
            goToFocus(cpfCnpjRef);
            alertModal('Informe o CPF/CNPJ.');
            return false;
        }

        if (!form.idestrangeiro) {

            if (!validarCPFCNPJ(form.cpfcnpj.trim())) {
                goToFocus(cpfCnpjRef);
                alertModal('CPF/CNPJ inválido.');
                return false;
            }
        }

        if (form.codBanco.trim() === "") {
            goToFocus(codBancoRef);
            alertModal('Informe o Cod. Banco');
            return false;
        }

        if (form.codAgencia.trim() === "") {
            goToFocus(codAgenciaRef);
            alertModal('Informe o Cod. Agencia');
            return false;
        }

        if (form.CNPJIPEF.trim() === "" && form.PIX === "") {
            goToFocus(CNPJIPEFRef);
            alertModal('Informe o CNPJ Inst. Pagto Ou a chave PIX.');
            return false;
        }

        if (form.CNPJIPEF.trim() !== "" && !validarCNPJ(form.CNPJIPEF.trim())) {
            goToFocus(CNPJIPEFRef);
            alertModal('CNPJ inválido.');
            return false;
        }

        if (form.vContrato === 0) {
            goToFocus(vContratoRef);
            alertModal('Informe o valor do contrato.');
            return false;
        }

        if (form.comp?.length === 0) {
            alertModal('Informe pelo menos um componente');
            return false;
        }

        if (form.comp && form.comp.length > 0) {
            const totalComponentes = form.comp.reduce((total: number, item: CompPagFrete) => total + item.vComp, 0);
            if (totalComponentes !== form.vContrato) {
                alertModal('A somatória dos componentes diferente do Valor do Contrato!');
                return false;
            }

        }
        return true;
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeNumeric = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: strToFloat(value)
        }))
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addInfPag(form));
            setForm(initialForm);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação",
        })
        if (confirmed) {
            dispatch(removeInfPag(value.id));

        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação",
            })
            if (confirmed) {
                goToFocus(cpfCnpjRef);
                dispatch(removeInfPagTodos());
            }
        }
    }

    const checkCom = () => {
        if (form.comp === undefined) {
            return false;
        } else {
            if (form.comp?.length > 0) {
                return true
            }
        }
        return false;
    }

    const checkPrazo = () => {
        if (form.infPrazo === undefined) {
            return false;
        } else {
            if (form.infPrazo?.length > 0) {
                return true
            }
        }
        return false;
    }

    const checkValorContrato = () => {
        if (checkCom() || checkPrazo()) {
            return true;
        }

        return false;
    }

    const checkPrazoPagto = () => {
        if (form.infPrazo === undefined) {
            return false;
        } else {
            if (form.infPrazo.length > 0) {
                return true;
            }
        }

        return false;
    }

    return (<>
        <div className="row g-3">
            <Card className="card-primary card-outline mb-3">
                <Card.Body className="px-1"
                >
                    <Row>
                        <Col md={7} className="border-end border-bottom">
                            <Row className="mb-3 g-2">

                                <Col md={3}>
                                    <Form.Group controlId="infpagfrete-cpfcnpj">
                                        <Form.Label>* CPF/CNPJ</Form.Label>
                                        <Form.Control value={form.cpfcnpj} name="cpfcnpj"
                                            ref={cpfCnpjRef}
                                            onChange={handleChange} onKeyUp={handleNumberOnly} maxLength={20} />
                                    </Form.Group>
                                </Col>

                                <Col md={3} className="d-flex align-items-end ">
                                    <Form.Group controlId="active">
                                        <Form.Switch className="mb-0" type="switch" name="active" label="Estrangeiro?" />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="infpagfrete-xNome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control value={form.xNome} onChange={handleChange} maxLength={60}
                                            name="xNome" />
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md>
                                    <Form.Group controlId="indPag">
                                        <Form.Label>Ind. Forma Pagto</Form.Label>
                                        <Form.Select value={form.indPag} name="indPag" disabled={checkPrazoPagto()}
                                            onChange={handleChange}>
                                            <option value="0">À vista</option>
                                            <option value="1">À prazo</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="vAdiant">
                                        <Form.Label>Valor Adiantamento</Form.Label>
                                        <Form.Control value={form.vAdiant} min={0} type="number" name="vAdiant"
                                            onChange={handleChangeNumeric}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="vContrato">
                                        <Form.Label>* Valor do Contrato</Form.Label>
                                        <Form.Control value={form.vContrato} min={0} type="number" name="vContrato"
                                            ref={vContratoRef}
                                            onChange={handleChangeNumeric} disabled={checkValorContrato()}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md={5}>
                                    <Form.Group className="mb-3" controlId="tpAnticip">
                                        <Form.Label>Tipo Antecipação</Form.Label>
                                        <Form.Select value={form.tpAntecip} name="tpAnticip"
                                            onChange={handleChange}>
                                            <option value="0">0 - Não permite antecipar</option>
                                            <option value="1">1 - Permite antecipar as parcelas</option>
                                            <option value="2">
                                                2 - Permite antecipar as parcelas mediante confirmação
                                            </option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md className="d-flex align-items-end mb-3 ">
                                    <Form.Group controlId="indAltoDesemp">
                                        <Form.Switch className="mb-0" type="switch" name="indAltoDesemp"
                                            label="Alto Desempenho?" />
                                    </Form.Group>
                                </Col>

                                <Col md className="d-flex align-items-end mb-3">
                                    <Form.Group controlId="indAntecipaAdiant">
                                        <Form.Switch className="mb-0" type="switch" name="indAntecipaAdiant"
                                            label="Pode Antecipar?" />
                                    </Form.Group>
                                </Col>

                            </Row>

                            <Row className="mb-3 g-2">
                                <Col md={2}>
                                    <Form.Group controlId="codBanco">
                                        <Form.Label>* Banco</Form.Label>
                                        <Form.Control value={form.codBanco} maxLength={5} name="codBanco"
                                            ref={codBancoRef}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={2}>
                                    <Form.Group controlId="codAgencia">
                                        <Form.Label>* Agencia</Form.Label>
                                        <Form.Control value={form.codAgencia} maxLength={10} name="codAgencia"
                                            ref={codAgenciaRef}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="CNPJIPEF">
                                        <Form.Label>CNPJ Inst. Pg Frete</Form.Label>
                                        <Form.Control value={form.CNPJIPEF} maxLength={14} name="CNPJIPEF"
                                            ref={CNPJIPEFRef}
                                            onKeyUp={handleNumberOnly} onChange={handleChange} />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="PIX">
                                        <Form.Label>Chave Pix</Form.Label>
                                        <Form.Control value={form.PIX} maxLength={60} name="PIX"
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={'auto'} className="d-flex align-items-end">
                                    <Button onClick={handleAdd} title="Adicionar na lista">
                                        <FontAwesomeIcon icon={faPlus} /> Adicionar
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                        <Col md className="border-bottom">
                            <Row>
                                <Col md>
                                    <div className="nav nav-underline" id="v-pills-tab" role="tablist">
                                        <button className="nav-link active" id="tab1-tab" data-bs-toggle="pill"
                                            data-bs-target="#tab1" type="button" role="tab"
                                        >
                                            Componentes
                                        </button>
                                        <button className="nav-link" id="tab2-tab" data-bs-toggle="pill"
                                            data-bs-target="#tab2" type="button" role="tab">Prazo Pagto</button>
                                    </div>

                                    <div className="tab-content pt-2 px-2" id="v-pills-tabContent">
                                        <div className="tab-pane fade show active" id="tab1" role="tabpanel">
                                            <Componente form={form} setForm={setForm} />
                                        </div>
                                        <div className="tab-pane fade" id="tab2" role="tabpanel" >
                                            <PrazoPagto form={form} setForm={setForm} />
                                        </div>

                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md>
                            <JTable>
                                <JTHead>
                                    <tr>
                                        <th className="text-center" style={{ width: '2.5rem' }}>
                                            <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                                        </th>
                                        <th>Nome</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Valor do Contrato</th>
                                    </tr>
                                </JTHead>
                                <JTBody>
                                    {lista?.map((item: infPagInterface) => (
                                        <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                            <td className="d-flex justify-content-around ">
                                                <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.cpfcnpj })} />
                                            </td>
                                            <td>{item.xNome}</td>
                                            <td>{item.cpfcnpj}</td>
                                            <td>{formatMoeda(item.vContrato)}</td>
                                        </tr>
                                    ))}
                                </JTBody>
                            </JTable>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>


        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
